import React, {useState, useRef, useEffect} from "react";
import {withRouter} from "react-router-dom";
import {useActivate, useUnactivate} from "react-activation";
import {NavBar, Form, Input, Button} from "antd-mobile";
import ChuangShiOS from "chuangshi-os-mobile-component";

import Application from "../../common/Application";
import {isWechat} from "../../utils/wechat";

import Style from "./Index.module.css";

const Login = (props) => {
    const request = useRef(false);
    const [isLaunch, setIsLaunch] = useState(false);

    useEffect(() => {
        setIsLaunch(true);
        //如果存在token，直接跳转
        if (ChuangShiOS.Util.getToken()){
            setTimeout(() => ChuangShiOS.Util.validateLoginCallback(props, {}), 100);
        }
        //eslint-disable-next-line
    }, []);

    useActivate(() => {});

    useUnactivate(() => {});

    const handleSubmit = (data) => {
        if (request.current) {
            return;
        }
        request.current = true;

        ChuangShiOS.Util.toastLoad();

        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/member/consumer/mobile/v1/login",
            data: data,
            success: (response) => {
                ChuangShiOS.Util.setToken(response.data.token);

                ChuangShiOS.Notification.emit("member_find_succes", {});

                console.log(props.history)

                // 如果是微信访问，跳转微信授权绑定openid，微信支付需要使用openid
                if (isWechat()){
                    handleWechatOauth2Authorize();
                }else{
                    ChuangShiOS.Util.toastSuccess({
                        message: "登录成功",
                        complete: () => {},
                    });
                    setTimeout(() => ChuangShiOS.Util.validateLoginCallback(props, {}), 2000);
                }
            },
            error: (response) => {
                ChuangShiOS.Util.toastError({
                    message: response.message,
                    complete: () => {},
                });
            },
            complete: (response) => {
                request.current = false;
            },
        });
    };

    const handleClickRegister = () => {
        ChuangShiOS.Util.redirectTo(props, {
            url: "/register/index",
        });
    };

    const handleClickForget = () => {
        ChuangShiOS.Util.redirectTo(props, {
            url: "/forget/index",
        });
    };

    // 获取微信授权链接
    const handleWechatOauth2Authorize=()=>{
        console.log("handleWweixinOauth ")
        // 非微信客户端，不进入微信授权
        if (!isWechat()){
            console.log("handleWweixinOauth 非微信客户端")
            return
        }
        console.log("handleWweixinOauth 是微信客户端")
        ChuangShiOS.Util.toastLoad();
        ChuangShiOS.Util.request(props, {
            url: Application.host + "/windeal/member/wechat/oauth2/authorize",
            data: { cburl: window.location.href },
            success: (response) => {
                console.log("handleWweixinOauth 微信授权链接 ",response.data.oauthUrl)
                ChuangShiOS.Util.toastHide();
                window.location = response.data.oauthUrl;
            },
            error: (response) => {
                ChuangShiOS.Util.toastError({
                    message: response.message,
                    complete: () => {},
                });
            },
            complete: (response) => {

            },
        });
    }

    return (
        <ChuangShiOS.Page>
            <NavBar
                back="返回"
                style={{
                    "--border-bottom": "1px #eee solid",
                }}
                onBack={() => {
                    ChuangShiOS.Util.navigateBack(props);
                }}
            >
                会员登录
            </NavBar>
            <ChuangShiOS.Content isLaunch={isLaunch} loadingColor={"#c26b60"}>
                <div className={Style.empty}></div>
                <Form
                    layout="horizontal"
                    footer={
                        <Button block type="submit" color="primary">
                            登录
                        </Button>
                    }
                    onFinish={handleSubmit}
                >
                    <Form.Item name="memberPhone" label="手机号码" rules={[{required: true, message: "请输入手机号码"}]}>
                        <Input type="number" placeholder="请输入手机号码" />
                    </Form.Item>
                    <Form.Item name="memberPassword" label="登录密码" rules={[{required: true, message: "请输入登录密码"}]}>
                        <Input type="password" placeholder="请输入登录密码" />
                    </Form.Item>
                </Form>
                <div className={Style.action}>
                    <div className={Style.action_item} onClick={handleClickRegister}>
                        免费注册
                    </div>
                    <div className={Style.action_item} onClick={handleClickForget}>
                        忘记密码？
                    </div>
                </div>
            </ChuangShiOS.Content>
        </ChuangShiOS.Page>
    );
};

Login.propTypes = {};

Login.defaultProps = {};

export default withRouter(Login);
